import {StyleSheet} from "aphrodite-jss"

export const styles = StyleSheet.create({
    container : {
        height: "min-content",
        minHeight: "200px",
        maxHeight: "800px",
        width: "1000px",
        backgroundColor: "transparent",
    },
});


// WEBPACK FOOTER //
// ./src/components/dialogs/PublicationSourceDialogStyle.ts